module.exports = __webpack_public_path__ + "assets/my-land.561fa214.svg";